import { OptionInfo, OptionVersion, TopicInfo } from '../../shared/interfaces';
import { TreeSortMode } from '../../shared/models';
import { SubsectionTreeService } from '../services/subsection-tree.service';

export function populateTopicSortData(topics: TopicInfo[], options: OptionInfo[]) {
  if (options.length == 0 || topics.length == 0) {
    return;
  }

  options.forEach((option) => {
    const topic = topics.find((topic) => topic.topicId === option.topicId);
    if (!topic) {
      return;
    }
    if (option.lastUploaded) {
      topic.lastUpload = topic.lastUpload ? Math.max(topic.lastUpload, option.lastUploaded) : option.lastUploaded;
    }
    if (option.firstUploaded) {
      topic.firstUpload = topic.firstUpload ? Math.min(topic.firstUpload, option.firstUploaded) : option.firstUploaded;
    }
    if (option.updatedAt) {
      topic.updatedAt = topic.updatedAt ? Math.max(topic.updatedAt, option.updatedAt) : option.updatedAt;
    }
  });
}

export function sortOptions(options: OptionInfo[], orderBy: TreeSortMode) {
  switch (orderBy) {
    case 'lastUpdated':
      options?.sort((a, b) => (b.updatedAt || 0) - (a.updatedAt || 0));
      break;
    case 'lastUpload':
      options?.sort((a, b) => (b.lastUploaded || 0) - (a.lastUploaded || 0));
      break;
    case 'firstUpload':
      options?.sort((a, b) => (a.firstUploaded || 0) - (b.firstUploaded || 0));
      break;
    default:
      options?.sort((a, b) => (a.title || '').localeCompare(b.title || '', undefined, { sensitivity: 'base' }));
      break;
  }
}

export function sortTopics(topics: TopicInfo[], orderBy: TreeSortMode) {
  switch (orderBy) {
    case 'lastUpdated':
      topics?.sort((a, b) => (b.updatedAt || 0) - (a.updatedAt || 0));
      break;
    case 'lastUpload':
      topics?.sort((a, b) => (b.lastUpload || 0) - (a.lastUpload || 0));
      break;
    case 'firstUpload':
      topics?.sort((a, b) => (a.firstUpload || 0) - (b.firstUpload || 0));
      break;
    default:
      topics?.sort((a, b) => (a.title || '').localeCompare(b.title || '', undefined, { sensitivity: 'base' }));
      break;
  }
}

export function sortVersionData(data: {
  version: OptionVersion;
  orderBy: TreeSortMode;
  sortTree: boolean;
  subsectionTreeService: SubsectionTreeService;
}) {
  const { version, orderBy = TreeSortMode.alphabetical, sortTree = true, subsectionTreeService } = data;

  if (!version?.files) {
    return;
  }

  switch (orderBy) {
    case TreeSortMode.lastUpdated:
    case TreeSortMode.lastUpload:
      version.files.sort((a, b) => (b.timeCreated || 0) - (a.timeCreated || 0));
      break;
    case TreeSortMode.firstUpload:
      version.files.sort((a, b) => (a.timeCreated || 0) - (b.timeCreated || 0));
      break;
    default:
      version.files.sort((a, b) => (a.displayName || '').localeCompare(b.displayName || ''));
      break;
  }

  if (sortTree) {
    subsectionTreeService.sortVersionFilesById(version.optionId + '-' + version.versionNumber, orderBy);
  }
}

export function getVersionId(optionId: string, version: number): string {
  return `${optionId}-${version}`;
}

export function getVersionTitle(optionName: string, version: number): string {
  return `${optionName} - ${version}`;
}

export function getOptionIdFromVersionId(versionId: string): string {
  return versionId.split('-').slice(0, -1).join('-');
}
